import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { translate } from "react-i18next"


class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.showMessage = this.showMessage.bind(this);
        this.state = 
        {
            message: "",
        };
    }
  
    showMessage(message) {
        this.setState({
            message: message,
        });
    }

    render() {  
    const { t } = this.props      
    return (
      <StaticQuery
        query={graphql`
          query ContactQuery {
            site {
              siteMetadata {
                mail,
                tel,
                address,
                facebook,
                instagram,
                twitter,
                xing,
                linkedin,
              }
            }
          }
        `}
        render={data => (
            <section id="contact" className="cards-top pagefiller">
                <div className="inner">
                    <section>
                        <header className="major">
                        <h2>{t("contact_form_subtitle", "Kontaktformular")}</h2>
                        </header>
                        {/* <p>{t("contact_form_subtitle", "Kontaktformular")}</p> */}
                        <p>{t("contact_form_text", "Fragen, Anmerkungen, Feedback? Wir möchten immer etwas verbessern, anpassen und erweitern. Darum sind wir in unser Startphase ganz klar auf deine Unterstützung angewiesen. Schreib uns einfach. Auch wenn du eine Frage zur Anmeldung oder ein anderes Anliegen hast: Wir freuen uns riesig über deine Nachricht.")}</p>
                    <Formik
                        initialValues={{ name: '', email: '', message: '' }}
                        validate={values => {
                            const errors = {};
                            if (!values.name) {
                                errors.name = t("contact_form_mandatory", "* Pflichtfeld");
                            }
                            if (!values.email) {
                                errors.email = t("contact_form_mandatory", "* Pflichtfeld");
                            } else if (
                                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                            ) {
                                errors.email = t("contact_form_mail_error", "Keine gültige Mail-Adresse");
                            }
                            if (!values.message) {
                                errors.message = t("contact_form_mandatory", "* Pflichtfeld");
                            }
                            return errors;
                        }}
                        onSubmit={(values, { setSubmitting, resetForm, initialValues}) => {
                            setTimeout(() => {

                            fetch('https://formspree.io/f/mdoynwan', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(values, null, 2),
                            })
                            .then(response => response.json())
                            .then(data => {
                                console.log('Success:', data);
                                this.showMessage(t("contact_form_success", "Die Nachricht wurde erfolgreich verschickt"));
                            })
                            .catch((error) => {
                                console.error('Error:', error);
                                this.showMessage(t("contact_form_error", "Die Nachricht konnte leider nicht gesendet werden"));
                            });

                            setSubmitting(false);
                            resetForm(initialValues)

                            }, 400);
                        }}
                        >
                        {({ isSubmitting }) => (
                            <Form>
                                <div className="field half first">
                                    <label htmlFor="name">{t("contact_form_name", "Name")}</label>
                                    <Field type="text" name="name" />
                                    <ErrorMessage name="name" component="div" />
                                </div>
                                <div className="field half">
                                    <label htmlFor="email">{t("contact_form_mail", "Mail")}</label>
                                    <Field type="email" name="email" />
                                    <ErrorMessage name="email" component="div" />
                                </div>
                                <div className="field">
                                    <label htmlFor="message">{t("contact_form_message", "Nachricht")}</label>
                                    <Field name="message" as="textarea" rows="6"/>
                                    <ErrorMessage name="message" component="div" />
                                </div>
                                <button type="submit" disabled={isSubmitting}>
                                    {t("contact_form_button", "Senden")}
                                </button>
                                <br/><br/>
                                <p>{this.state.message}</p>
                            </Form>
                        )}
                        </Formik>
                        
                    </section>
                    <section className="split pagefiller">
                        <section>
                            <div className="contact-method">
                                <span className="icon alt fa-envelope"></span>
                                <h3>{t("contact_mail", "Mail")}</h3>
                                <a href={"mailto:"+data.site.siteMetadata.mail}>{data.site.siteMetadata.mail}</a>
                            </div>
                        </section>
                        <section>
                            <div className="contact-method">
                                <span className="icon alt fa-whatsapp"></span>
                                <h3>{t("contact_phone", "Whatsapp")}</h3>
                                <a href={"https://wa.me/491632221616"}>{data.site.siteMetadata.tel}</a>
                            </div>
                        </section>
                        <section>
                            <div className="contact-method">
                                <span className="icon alt fa-home"></span>
                                <h3>{t("contact_address", "Adresse")}</h3>
                                <a href="https://www.google.de/maps/place/Hanover">{data.site.siteMetadata.address}</a>
                            </div>
                        </section>
                        <section>
                            <div className="contact-method">
                                <span className="icon alt fa-hashtag"></span>
                                <h3>{t("contact_social_media", "Soziale Medien")}</h3>
                                <div>
                                    <ul className="alt">
                                        <li>
                                        <a href={data.site.siteMetadata.twitter} target="_blank" rel="noreferrer" aria-label="Twitter" className="">
                                            <span>Twitter</span>
                                        </a>
                                        </li>
                                        <li>
                                        <a href={data.site.siteMetadata.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="">
                                            <span>Facebook</span>
                                        </a>
                                        </li>
                                        <li>
                                        <a href={data.site.siteMetadata.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="">
                                            <span>Instagram</span>
                                        </a>
                                        </li>
                                        <li>
                                        <a href={data.site.siteMetadata.xing} target="_blank" rel="noreferrer" aria-label="Xing" className="">
                                            <span>Xing</span>
                                        </a>
                                        </li>
                                        <li>
                                        <a href={data.site.siteMetadata.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="">
                                            <span>LinkedIn</span>
                                        </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </section>
                    </section>
                </div>
            </section>
          )}
          />
        )
    }
} 

export default translate("Index")(Contact)